module.exports = __webpack_public_path__ + "stylesheets/wave-template-item_e47e70e85543554f5746b074a2caa775.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/wave/wave-template-item.less
// module id = aTCW
// module chunks = 55